import { useCallback } from "react";
import { useHistory } from "react-router-dom";

import { useNavigationHooks } from "..";
import { INotification, UrlQueryParams } from "../../store/types";
import { JSON_to_URLEncoded } from "../../utils/json-to-url-encoded";
import { NotificationHandlerType } from "./use-click-handler";

export function useNoteHook(): NotificationHandlerType {
  const { getNotePathName } = useNavigationHooks();
  const { push } = useHistory();

  return useCallback(async ({ components }: INotification) => {
    const searchObj: UrlQueryParams = {
      section: components.section_id
    };

    if (components.type === "deleted") return;
    if (components.form_id) {
      searchObj.boxFormAttach = components.form_id;
    }
    if (components.note_id) {
      push({
        pathname: getNotePathName(components.deal_id, components.note_id),
        search: JSON_to_URLEncoded(searchObj)
      });
    }
  }, []);
}
